export const DASHBOARD_TEXT = {
    ar: {
      
        admin: "صفحة الإدارة",
        customer: "صفحة العميل",
        accountant: "صفحة المحاسب",
        cashier: "صفحة الكاشير",
        actions: "صفحة الإجراءات",
        applications: "التطبيقات",
        accounts: "حسابات المستخدم",
        managers: "مدراء الحسابات",
        campaigns: "أحدث الحملات",
        branches: "الفروع",
        performance: "كرت الأداء",
        completion: "اكتمال بيانات الحساب",
        requests: "الإجراءات",
        addActivation: "إضافة تفعيل",
        addAccount: "إضافة حساب",
        addManager: "إضافة مدير حساب",
        addCampaign: "إضافة حملة",
        addBranch: "إضافة فرع جديد",
        platformLink: "رابط المنصة",
        status: "الحالة",
        active: "فعال",
        inactive: "غير فعال",
        inProgress: "جاري العمل",
        pending: "قيد المراجعة",
        approved: "مقبول",
        rejected: "مرفوض",
        approve: "موافقة",
        reject: "رفض",
        save: "حفظ",
        cancel: "إلغاء",
        edit: "تعديل",
        close: "إغلاق",
        firstShift: "الفترة الأولى",
        secondShift: "الفترة الثانية",
        closed: "مغلق",
        noData: "لا توجد بيانات",
        requestedByCustomer: "تم إنشاء طلب للإدارة ولم يطبق التعديل مباشرة.",
        subscription: {
            account: "الحساب",
            accountStatus: "حالة الحساب",
            package: "الباقة",
            packagePrefix: "باقة",
            startDate: "البداية",
            endDate: "الانتهاء",
            remaining: "المتبقي",
            days: "يوم",
            cancellationEffective: "الإلغاء يسري في",
            coveredBranches: "الفروع المغطّاة",
            ofTotal: "من",
            uncoveredBranches: "فروع غير مغطّاة",
            grantedUntil: "اشتراك ممنوح من لود حتى",
            converting: "المنحة المجانية تنتهي في",
            uncoveredNotice: "بعض فروعك التشغيلية بلا تغطية اشتراك ساريةً. جدّد أو أضف تغطية حتى لا يتوقف تفعيلها.",
            coverageAction: "إدارة الاشتراك والتغطية",
            platformCardTitle: "اشتراكك باقي له",
            integrationCardTitle: "اشتراك التكامل باقي له",
            daysRemaining: "{days} يوم متبقي",
            endsOn: "ينتهي في",
            loading: "جارٍ تحميل بيانات الاشتراك…",
            error: "تعذّر تحميل بيانات الاشتراك",
            unavailable: "بيانات الاشتراك غير متاحة",
            unpaidInvoices: "فواتير تحتاج متابعة",
            accountStatuses: {
                active: "نشط",
                past_due: "متأخر السداد",
                suspended: "موقوف",
                pending: "قيد التفعيل",
                inactive: "غير نشط",
            },
            statuses: {
                active: "اشتراك ساري",
                scheduled_for_cancellation: "ساري حتى الإلغاء المجدول",
                past_due: "اشتراك متأخر السداد",
                suspended: "اشتراك موقوف",
                draft: "اشتراك بانتظار التفعيل",
                canceled: "اشتراك ملغي",
                none: "لا يوجد اشتراك",
                periodEnded: "انتهت فترة الاشتراك",
            },
        },
        billingStats: {
            invoiceCount: "عدد الفواتير",
            invoiceValue: "قيمة الفواتير (ر.س)",
            paidValue: "قيمة المدفوع (ر.س)",
            unpaidValue: "قيمة غير المدفوع (ر.س)",
            expiringSubscriptions: "اشتراكات قرب الانتهاء",
            subscriptions: "الاشتراكات",
            invoices: "الفواتير",
            error: "تعذّر تحميل بيانات الفوترة",
            subscriptionStatuses: {
                active: "فعال",
                scheduled_for_cancellation: "مجدول للإلغاء",
                past_due: "متأخر السداد",
                suspended: "موقوف",
                draft: "جاري العمل",
                canceled: "ملغي",
                withoutSubscription: "بدون اشتراك",
            },
            invoiceStatuses: {
                paid: "مدفوع",
                awaiting_payment: "غير مدفوع",
                finance_review: "قيد المراجعة",
                cancelled: "ملغاة",
            },
        },
    },
    en: {
        
        admin: "Admin View",
        customer: "Customer View",
        accountant: "Accountant Page",
        cashier: "Cashier Page",
        actions: "Actions Page",
        applications: "Applications",
        accounts: "User Accounts",
        managers: "Account Managers",
        campaigns: "Latest Campaigns",
        branches: "Branches",
        performance: "Performance Card",
        completion: "Account Data Completion",
        requests: "Actions",
        addActivation: "Add Activation",
        addAccount: "Add Account",
        addManager: "Add Account Manager",
        addCampaign: "Add Campaign",
        addBranch: "Add New Branch",
        platformLink: "Platform Link",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        inProgress: "In Progress",
        pending: "Under Review",
        approved: "Approved",
        rejected: "Rejected",
        approve: "Approve",
        reject: "Reject",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        close: "Close",
        firstShift: "First Shift",
        secondShift: "Second Shift",
        closed: "Closed",
        noData: "No data",
        requestedByCustomer: "A request was created for admin review; the change was not applied directly.",
        subscription: {
            account: "Account",
            accountStatus: "Account Status",
            package: "Package",
            packagePrefix: "Package",
            startDate: "Start",
            endDate: "End",
            remaining: "Remaining",
            days: "days",
            cancellationEffective: "Cancellation effective",
            coveredBranches: "Covered branches",
            ofTotal: "of",
            uncoveredBranches: "Uncovered branches",
            grantedUntil: "Subscription granted by LUD until",
            converting: "Free coverage ends on",
            uncoveredNotice: "Some of your operational branches have no valid subscription coverage. Renew or add coverage so they can stay activated.",
            coverageAction: "Manage subscription and coverage",
            platformCardTitle: "Platform Subscription",
            integrationCardTitle: "Integration Subscription",
            daysRemaining: "{days} days remaining",
            endsOn: "Ends on",
            loading: "Loading subscription…",
            error: "Could not load subscription",
            unavailable: "Subscription details unavailable",
            unpaidInvoices: "Invoices to Follow",
            accountStatuses: {
                active: "Active",
                past_due: "Past due",
                suspended: "Suspended",
                pending: "Pending activation",
                inactive: "Inactive",
            },
            statuses: {
                active: "Subscription active",
                scheduled_for_cancellation: "Active until scheduled cancellation",
                past_due: "Subscription past due",
                suspended: "Subscription suspended",
                draft: "Subscription pending activation",
                canceled: "Subscription canceled",
                none: "No subscription",
                periodEnded: "Subscription period ended",
            },
        },
        billingStats: {
            invoiceCount: "Invoices",
            invoiceValue: "Invoices value (SAR)",
            paidValue: "Paid amount (SAR)",
            unpaidValue: "Unpaid amount (SAR)",
            expiringSubscriptions: "Subscriptions expiring soon",
            subscriptions: "Subscriptions",
            invoices: "Invoices",
            error: "Could not load billing data",
            subscriptionStatuses: {
                active: "Active",
                scheduled_for_cancellation: "Scheduled for cancellation",
                past_due: "Past due",
                suspended: "Suspended",
                draft: "In Progress",
                canceled: "Canceled",
                withoutSubscription: "No subscription",
            },
            invoiceStatuses: {
                paid: "Paid",
                awaiting_payment: "Unpaid",
                finance_review: "Under review",
                cancelled: "Cancelled",
            },
        },
    },
};
